import React from 'react';
import BackButton from '../../main/BackButton';
import Text from '../../main/Text';

export default function Gifts() {
    return (
        <>
            <BackButton />
            <Text>
in the past, every item we sold came with a gift, but over
time we realized that model wasn’t financially viable and
became logistically difficult to maintain. we still believe
deeply in gift giving, we’re just doing it different. instead of
tying gifts to purchases, we’ll now give gifts randomly,
whenever we want, with no purchase required.            </Text>

        </>
    )
}
